import {
  CasinoOutlined as RevolverIcon,
  SportsEsportsOutlined as MineIcon,
  AutoAwesomeOutlined as MRLIcon,
  RocketLaunchOutlined as MissileIcon,
} from "@mui/icons-material";
import {
  colors,
  LOTTERY_COLOR_THEMES,
  getLotteryColorTheme,
  SPINBET_COLOR_THEME,
  MINEBET_COLOR_THEME,
  MEGABET_COLOR_THEME,
  ROCKETBET_COLOR_THEME,
  THREESLOT_COLOR_THEME,
  FIVESLOT_COLOR_THEME,
} from "../theme/colors";
import { networkID } from "./utils";

// 3-Slot & 5-Slot Active 3D Cryptocurrency Slot Symbols
import btcCoin3dImg from "./Images/slot_icons/crypto_3d/btc.png";
import ethCoin3dImg from "./Images/slot_icons/crypto_3d/eth.png";
import polCoin3dImg from "./Images/slot_icons/crypto_3d/pol.png";
import solCoin3dImg from "./Images/slot_icons/crypto_3d/sol.png";
import bnbCoin3dImg from "./Images/slot_icons/crypto_3d/bnb.png";
import usdtCoin3dImg from "./Images/slot_icons/crypto_3d/usdt.png";

// 3-Slot & 5-Slot Active Casino Slot Symbols
import crownGemSymbolImg from "./Images/slot_icons/3_slot_gems/crown.png";
import diamondGemSymbolImg from "./Images/slot_icons/3_slot_gems/diamond.png";
import bellSymbolImg from "./Images/slot_icons/3_slot_gems/bell.png";
import cherries3dSymbolImg from "./Images/slot_icons/3_slot_gems/cherries.png";
import lucky7GemSymbolImg from "./Images/slot_icons/3_slot_gems/lucky_7.png";
import cloverSymbolImg from "./Images/slot_icons/3_slot_gems/clover.png";
import coinSymbolImg from "./Images/slot_icons/3_slot_gems/coin.png";
import autobetCoinSymbolImg from "./Images/slot_icons/3_slot_gems/autobet_coin.png";

export {
  btcCoin3dImg,
  ethCoin3dImg,
  polCoin3dImg,
  solCoin3dImg,
  bnbCoin3dImg,
  usdtCoin3dImg,
  crownGemSymbolImg,
  diamondGemSymbolImg,
  bellSymbolImg,
  cherries3dSymbolImg,
  lucky7GemSymbolImg,
  cloverSymbolImg,
  coinSymbolImg,
  autobetCoinSymbolImg,
};

/**
 * Single source of truth for all slot and pokies machine symbol images.
 * Any future updates or changes to icons should be maintained here,
 * and will automatically reflect on all pages across the application.
 */
export const SLOT_SYMBOL_IMAGES = {
  // Bell (Contract #0 Fiat)
  bell: bellSymbolImg,
  golden_bell: bellSymbolImg,
  BELL: bellSymbolImg,

  // Diamond (Contract #1 Fiat)
  diamond: diamondGemSymbolImg,
  diamondGem: diamondGemSymbolImg,
  diamond_gem: diamondGemSymbolImg,
  DIAMOND: diamondGemSymbolImg,

  // Royal Crown (Contract #2 Fiat)
  crown: crownGemSymbolImg,
  crownGem: crownGemSymbolImg,
  jackpotCrown: crownGemSymbolImg,
  jackpot_crown: crownGemSymbolImg,
  CROWN: crownGemSymbolImg,

  // Casino Cherries (Contract #3 Fiat)
  cherries: cherries3dSymbolImg,
  cherry: cherries3dSymbolImg,
  cherries3d: cherries3dSymbolImg,
  CHERRY: cherries3dSymbolImg,

  // Lucky 7 (Contract #4 Fiat)
  lucky_7: lucky7GemSymbolImg,
  lucky7: lucky7GemSymbolImg,
  seven: lucky7GemSymbolImg,
  SEVEN: lucky7GemSymbolImg,

  // Lucky Clover (Contract #5 Fiat 5-Slot)
  clover: cloverSymbolImg,
  lucky_clover: cloverSymbolImg,
  luckyClover: cloverSymbolImg,
  kina_shell: cloverSymbolImg,
  kinaShell: cloverSymbolImg,
  CLOVER: cloverSymbolImg,

  // Golden Coin (Contract #6 Fiat 5-Slot - Top Symbol)
  coin: coinSymbolImg,
  golden_coin: coinSymbolImg,
  gold_coin: coinSymbolImg,
  goldenCoin: coinSymbolImg,
  goldCoin: coinSymbolImg,
  goldNugget: coinSymbolImg,
  gold_nugget: coinSymbolImg,
  COIN: coinSymbolImg,

  // AutoBET Golden Coin (Contract #6 Crypto 5-Slot - Top Symbol)
  autobet: autobetCoinSymbolImg,
  autobet_coin: autobetCoinSymbolImg,
  autobetCoin: autobetCoinSymbolImg,
  autobet_token: autobetCoinSymbolImg,
  autobetToken: autobetCoinSymbolImg,
  autobet_logo: autobetCoinSymbolImg,
  autobetLogo: autobetCoinSymbolImg,
  autobetLogoPng: autobetCoinSymbolImg,
  autobet_logo_png: autobetCoinSymbolImg,
  autobetLogoCrypto: autobetCoinSymbolImg,
  autobet_logo_crypto: autobetCoinSymbolImg,
  AUTOBET: autobetCoinSymbolImg,

  // Polygon POL (Contract #0 Crypto)
  pol: polCoin3dImg,
  polCoin: polCoin3dImg,
  pol_coin: polCoin3dImg,
  polygon: polCoin3dImg,
  POL: polCoin3dImg,

  // Ethereum ETH (Contract #1 Crypto)
  eth: ethCoin3dImg,
  ethCoin: ethCoin3dImg,
  eth_coin: ethCoin3dImg,
  ethereum: ethCoin3dImg,
  ethCrystal: ethCoin3dImg,
  eth_crystal: ethCoin3dImg,
  ETH: ethCoin3dImg,

  // Bitcoin BTC (Contract #2 Crypto)
  btc: btcCoin3dImg,
  btcCoin: btcCoin3dImg,
  btc_coin: btcCoin3dImg,
  bitcoin: btcCoin3dImg,
  BTC: btcCoin3dImg,

  // Solana SOL (Contract #3 Crypto)
  sol: solCoin3dImg,
  solCoin: solCoin3dImg,
  sol_coin: solCoin3dImg,
  solana: solCoin3dImg,
  SOL: solCoin3dImg,

  // Tether USDT (Contract #4 Crypto)
  usdt: usdtCoin3dImg,
  usdtCoin: usdtCoin3dImg,
  usdt_coin: usdtCoin3dImg,
  tether: usdtCoin3dImg,
  jackpotOrb: usdtCoin3dImg,
  jackpot_orb: usdtCoin3dImg,
  USDT: usdtCoin3dImg,

  // Binance BNB (Contract #5 Crypto 5-Slot)
  bnb: bnbCoin3dImg,
  bnbCoin: bnbCoin3dImg,
  bnb_coin: bnbCoin3dImg,
  binance: bnbCoin3dImg,
  BNB: bnbCoin3dImg,
};

export const POKIES_SYMBOL_IMAGES = SLOT_SYMBOL_IMAGES;

/**
 * Single source of truth helper to resolve any slot symbol image.
 * Accepts a symbol identifier string or symbol object.
 * Any future update or change to an icon in Constants.js will automatically
 * propagate across all pages (3-slot, 5-slot, admin creation, paytables, etc.).
 */
export const getSlotSymbolImage = (symbolOrId) => {
  if (!symbolOrId) return null;
  if (typeof symbolOrId === "string") {
    return (
      SLOT_SYMBOL_IMAGES[symbolOrId] ||
      SLOT_SYMBOL_IMAGES[symbolOrId.toLowerCase()] ||
      null
    );
  }
  if (symbolOrId.image) return symbolOrId.image;
  const key = symbolOrId.id || symbolOrId.code || symbolOrId.key || symbolOrId.name;
  if (key) {
    return (
      SLOT_SYMBOL_IMAGES[key] ||
      SLOT_SYMBOL_IMAGES[String(key).toLowerCase()] ||
      null
    );
  }
  return null;
};

/**
 * Returns native blockchain currency ticker according to chain network ID.
 */
export const getNetworkCurrency = (netId) => {
  const id = Number(netId || networkID);
  if (id === 137 || id === 80002 || id === 80001) return "POL";
  if (id === 1 || id === 5 || id === 11155111) return "ETH";
  if (id === 56 || id === 97) return "BNB";
  return "POL";
};

export const DEFAULT_CURRENCY = getNetworkCurrency(networkID);
export const DEFAULT_TOKEN_SYMBOL = "BET";


/**
 * Network name lookup by chain network ID.
 */
export const NETWORK_NAMES = {
  137: "Polygon Mainnet",
  80002: "Polygon Amoy Testnet",
  80001: "Polygon Mumbai Testnet",
  1: "Ethereum Mainnet",
  5: "Goerli Testnet",
  11155111: "Sepolia Testnet",
  56: "BNB Smart Chain Mainnet",
  97: "BNB Smart Chain Testnet",
};

/**
 * Returns network name according to chain network ID.
 */
export const getNetworkName = (netId) => {
  const id = Number(netId || networkID);
  if (NETWORK_NAMES[id]) return NETWORK_NAMES[id];
  if (id) return `Network ${id}`;
  return "Unknown Network";
};

/**
 * Blockchain Explorer Constants & Helper
 */
export const EXPLORER_BASE_URL = "https://testnet.bscscan.com/address/";
export const EXPLORER_LABEL = "View on Bscscan";

export const getExplorerAddressUrl = (address) =>
  address ? `${EXPLORER_BASE_URL}${address}` : "";

export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;
export const PASSWORD_HELPER_TEXT = `Use at least ${MIN_PASSWORD_LENGTH} characters. Spaces and passphrases are welcome.`;

export const Path = {
  root: "/",
  login: "/login",
  verifyEmail: "/verify-email",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  wallet: "/wallet",
  walletAddBalance: "/wallet/add-balance",
  walletTransactions: "/wallet/transactions",
  walletApprovals: "/wallet/approvals",
  help: "/help",
  about: "/aboutus",
  register: "/signup",
  registerasorg: "/register",
  singlelottery: "/lottery/:id",
  admin: "/admins",
  adminorglist: "/admin/creatorslist",
  adminlotterylist: "/admin/lotterylist",
  adminlotterydetail: "/admin/lotterydetails/:id",
  org: "/creators",
  orgcreatelottery: "/creator/createlottery",
  orglotterydetail: "/creator/lotterydetails/:id",
  orgmylottery: "/creator/mylottery",
  alllottery: "/all-lottery",
  result: "/lottery-result",
  profile: "/profile",
  ThreeSlotlottery: "/all-three-slotlottery",
  ThreeSlotlotteryDetails: "/three-slotlottery/:id",
  FiveSlotlottery: "/all-five-slotlottery",
  FiveSlotlotteryDetails: "/five-slotlottery/:id",
  Spinnerlottery: "/spinnerlottery",
  adminpartnerslist: "/admin/partnerslist",
  minelottery: "/minelottery/:id",
  allminelottery: "/all-minelottery",
  missilelottery: "/missilelottery/:id",
  allmissilelottery: "/all-missilelottery",
  allgiftcards: "/all-giftcards",
  giftcard: "/giftcard/:id",
  orgcreatecard: "/creator/create-giftcard",
  mygiftcard: "/creator/mygiftcard",
  admingiftcard: "/admin/giftcardlist",
  admincarddetails: "/admin/giftcarddetails/:id",
  orgcarddetails: "/creator/giftcarddetails/:id",
  adminNews: "/admin/news",
  adminTaxation: "/admin/taxation",
  notifications: "/notifications",
  adminNotifications: "/admin/notifications",
  orgNotifications: "/creator/notifications",
  news: "/all-news",
  newsId: "/news/:id",
  lotterydetail: "/lotterydetails/:id",
  allLotteries: "/all-lotteries",
  terms: "/terms",
  notFound: "/404",

  // Base paths without param markers (for constructing links or checking location.pathname)
  adminLotteryDetailsBase: "/admin/lotterydetails",
  orgLotteryDetailsBase: "/creator/lotterydetails",
  adminGiftCardDetailsBase: "/admin/giftcarddetails",
  orgGiftCardDetailsBase: "/creator/giftcarddetails",
  userLotteryDetailsBase: "/lotterydetails",
  userGiftCardBase: "/giftcard",
  newsBase: "/news",
  revolverLotteryBase: "/lottery",
  mineLotteryBase: "/minelottery",
  missileLotteryBase: "/missilelottery",
  threeSlotLotteryBase: "/all-three-slotlottery",
  fiveSlotLotteryBase: "/five-slotlottery",

  // Helper Methods for Dynamic Links
  getLotteryDetails: (id) => `/lotterydetails/${id}`,
  getAdminLotteryDetails: (id) => `/admin/lotterydetails/${id}`,
  getCreatorLotteryDetails: (id) => `/creator/lotterydetails/${id}`,
  getGiftCardDetails: (id) => `/giftcard/${id}`,
  getAdminGiftCardDetails: (id) => `/admin/giftcarddetails/${id}`,
  getCreatorGiftCardDetails: (id) => `/creator/giftcarddetails/${id}`,
  getCreatorCreateThreeSlot: () => `/creator/createlottery?type=3slot`,
  getCreatorCreateFiveSlot: () => `/creator/createlottery?type=5slot`,
  getNewsDetails: (id) => `/news/${id}`,
  getRevolverLottery: (id) => `/lottery/${id}`,
  getMineLottery: (id) => `/minelottery/${id}`,
  getMissileLottery: (id) => `/missilelottery/${id}`,
  getThreeSlotLottery: (id) => `/three-slotlottery/${id}`,
  getFiveSlotLottery: (id) => `/five-slotlottery/${id}`,
  getLotteryPlayUrl: (id, type) => {
    const typeNum = Number(type);
    if (typeNum === 0) return "/spinnerlottery";
    if (typeNum === 1) return `/minelottery/${id}`;
    if (typeNum === 3) return `/missilelottery/${id}`;
    if (typeNum === 4) return `/three-slotlottery/${id}`;
    if (typeNum === 5) return `/five-slotlottery/${id}`;
    return `/lottery/${id}`;
  },
  getProfile: () => "/profile",
  getNotifications: (role) => {
    if (role === "admin") return "/admin/notifications";
    if (role === "creator") return "/creator/notifications";
    return "/notifications";
  },
};

/**
 * Centralized Lottery Game Type IDs
 */
export const LOTTERY_TYPE_IDS = {
  SPINBET: 0,
  MINEBET: 1,
  MEGABET: 2,
  ROCKETBET: 3,
  THREESLOT: 4,
  FIVESLOT: 5,
};

/**
 * Centralized Lottery Game Names Constants
 */
export const LOTTERY_NAMES = {
  SPINBET: "SpinBET",
  MINEBET: "MineBET",
  MEGABET: "MegaBET",
  ROCKETBET: "RocketBET",
  THREESLOT: "3-SlotBET",
  FIVESLOT: "5-SlotBET",
};

// Aliases and individual exports for flexible importing
export const GAME_NAMES = LOTTERY_NAMES;
export const SPINBET = LOTTERY_NAMES.SPINBET;
export const MINEBET = LOTTERY_NAMES.MINEBET;
export const MEGABET = LOTTERY_NAMES.MEGABET;
export const ROCKETBET = LOTTERY_NAMES.ROCKETBET;
export const THREESLOT = LOTTERY_NAMES.THREESLOT;
export const FIVESLOT = LOTTERY_NAMES.FIVESLOT;

/**
 * Centralized Lottery Game Type Mapper
 */
export const lotteryTypeMapper = {
  [LOTTERY_TYPE_IDS.SPINBET]: LOTTERY_NAMES.SPINBET,
  [LOTTERY_TYPE_IDS.MINEBET]: LOTTERY_NAMES.MINEBET,
  [LOTTERY_TYPE_IDS.MEGABET]: LOTTERY_NAMES.MEGABET,
  [LOTTERY_TYPE_IDS.ROCKETBET]: LOTTERY_NAMES.ROCKETBET,
  [LOTTERY_TYPE_IDS.THREESLOT]: LOTTERY_NAMES.THREESLOT,
  [LOTTERY_TYPE_IDS.FIVESLOT]: LOTTERY_NAMES.FIVESLOT,
};

/**
 * Returns lottery type display name by type ID from lotteryTypeMapper.
 */
export const getLotteryTypeName = (typeId) => {
  if (lotteryTypeMapper[typeId] !== undefined) return lotteryTypeMapper[typeId];
  return typeId !== undefined && typeId !== null ? `Lottery Type ${typeId}` : "Lottery";
};

/**
 * Centralized Lottery Result & Lifecycle Status Mapper
 */
export const resultStatusTypeMapper = {
  0: "Open",
  1: "Close",
  2: "Result Done",
  3: "Rollover",
  4: "Blocked",
  5: "Rollover Open",
  6: "Creation in progress",
};

/**
 * Sort Options for Lotteries
 */
export const LOTTERY_SORT_OPTIONS = [
  { value: "newest", label: "Newest First" },
  { value: "oldest", label: "Oldest First" },
  { value: "highestPrize", label: "Highest Prize" },
  { value: "lowestPrize", label: "Lowest Prize" },
  { value: "entryFee", label: "Entry Fee (High to Low)" },
];

export const lotterySortOptions = LOTTERY_SORT_OPTIONS;
export const sortOptions = LOTTERY_SORT_OPTIONS;

/**
 * Centralized Lottery Game Type Theme Configurations
 */
export const LOTTERY_TYPES = {
  [LOTTERY_TYPE_IDS.SPINBET]: {
    name: LOTTERY_NAMES.SPINBET,
    shortName: LOTTERY_NAMES.SPINBET,
    color: LOTTERY_COLOR_THEMES[0].color,
    lightColor: LOTTERY_COLOR_THEMES[0].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[0].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[0].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[0].borderColor,
    gradient: LOTTERY_COLOR_THEMES[0].gradient,
    glow: LOTTERY_COLOR_THEMES[0].glow,
    boxShadow: LOTTERY_COLOR_THEMES[0].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[0].hoverBorder,
    icon: RevolverIcon,
  },
  [LOTTERY_TYPE_IDS.MINEBET]: {
    name: LOTTERY_NAMES.MINEBET,
    shortName: LOTTERY_NAMES.MINEBET,
    color: LOTTERY_COLOR_THEMES[1].color,
    lightColor: LOTTERY_COLOR_THEMES[1].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[1].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[1].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[1].borderColor,
    gradient: LOTTERY_COLOR_THEMES[1].gradient,
    glow: LOTTERY_COLOR_THEMES[1].glow,
    boxShadow: LOTTERY_COLOR_THEMES[1].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[1].hoverBorder,
    icon: MineIcon,
  },
  [LOTTERY_TYPE_IDS.MEGABET]: {
    name: LOTTERY_NAMES.MEGABET,
    shortName: LOTTERY_NAMES.MEGABET,
    color: LOTTERY_COLOR_THEMES[2].color,
    lightColor: LOTTERY_COLOR_THEMES[2].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[2].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[2].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[2].borderColor,
    gradient: LOTTERY_COLOR_THEMES[2].gradient,
    glow: LOTTERY_COLOR_THEMES[2].glow,
    boxShadow: LOTTERY_COLOR_THEMES[2].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[2].hoverBorder,
    icon: MRLIcon,
  },
  [LOTTERY_TYPE_IDS.ROCKETBET]: {
    name: LOTTERY_NAMES.ROCKETBET,
    shortName: LOTTERY_NAMES.ROCKETBET,
    color: LOTTERY_COLOR_THEMES[3].color,
    lightColor: LOTTERY_COLOR_THEMES[3].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[3].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[3].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[3].borderColor,
    gradient: LOTTERY_COLOR_THEMES[3].gradient,
    glow: LOTTERY_COLOR_THEMES[3].glow,
    boxShadow: LOTTERY_COLOR_THEMES[3].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[3].hoverBorder,
    icon: MissileIcon,
  },
  [LOTTERY_TYPE_IDS.THREESLOT]: {
    name: LOTTERY_NAMES.THREESLOT,
    shortName: LOTTERY_NAMES.THREESLOT,
    color: LOTTERY_COLOR_THEMES[4].color,
    lightColor: LOTTERY_COLOR_THEMES[4].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[4].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[4].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[4].borderColor,
    gradient: LOTTERY_COLOR_THEMES[4].gradient,
    glow: LOTTERY_COLOR_THEMES[4].glow,
    boxShadow: LOTTERY_COLOR_THEMES[4].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[4].hoverBorder,
    icon: RevolverIcon,
  },
  [LOTTERY_TYPE_IDS.FIVESLOT]: {
    name: LOTTERY_NAMES.FIVESLOT,
    shortName: LOTTERY_NAMES.FIVESLOT,
    color: LOTTERY_COLOR_THEMES[5].color,
    lightColor: LOTTERY_COLOR_THEMES[5].lightColor,
    darkColor: LOTTERY_COLOR_THEMES[5].darkColor,
    bgColor: LOTTERY_COLOR_THEMES[5].bgColor,
    borderColor: LOTTERY_COLOR_THEMES[5].borderColor,
    gradient: LOTTERY_COLOR_THEMES[5].gradient,
    glow: LOTTERY_COLOR_THEMES[5].glow,
    boxShadow: LOTTERY_COLOR_THEMES[5].boxShadow,
    hoverBorder: LOTTERY_COLOR_THEMES[5].hoverBorder,
    icon: RevolverIcon,
  },
};

/**
 * Returns complete lottery type configuration object safely by type ID
 */
export const getLotteryTypeConfig = (typeId) => {
  const numericId = Number(typeId !== undefined && typeId !== null ? typeId : 0);
  return LOTTERY_TYPES[numericId] || LOTTERY_TYPES[0];
};

export {
  LOTTERY_COLOR_THEMES,
  getLotteryColorTheme,
  SPINBET_COLOR_THEME,
  MINEBET_COLOR_THEME,
  MEGABET_COLOR_THEME,
  ROCKETBET_COLOR_THEME,
  THREESLOT_COLOR_THEME,
  FIVESLOT_COLOR_THEME,
};

/**
 * Lottery Status Configurations
 */
export const STATUS_CONFIG = {
  0: { label: resultStatusTypeMapper[0] || "Open", variant: "active", color: colors.emerald[600], bg: colors.emerald[50] },
  1: { label: resultStatusTypeMapper[1] || "Closed", variant: "ended", color: colors.slate[600], bg: colors.slate[100] },
  2: { label: resultStatusTypeMapper[2] || "Result Done", variant: "ended", color: colors.slate[700], bg: colors.slate[100] },
  3: { label: resultStatusTypeMapper[3] || "Rollover", variant: "warning", color: colors.amber[700], bg: colors.amber[50] },
  4: { label: resultStatusTypeMapper[4] || "Blocked", variant: "danger", color: colors.red[600], bg: colors.red[50] },
  5: { label: resultStatusTypeMapper[5] || "Rollover Open", variant: "active", color: colors.cyan[700], bg: colors.cyan[50] },
  6: { label: resultStatusTypeMapper[6] || "Creation in progress", variant: "pending", color: colors.purple[600], bg: colors.purple[50] },
};
